import React, { useMemo } from "react";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import Application from "./application/containers";
import Login from "./login/container";
import ResetPassword from "./passwordReset/container";
import { Country } from "../shared/constants/Constant";
import Dashboard from "./dashboard/containers";
import Registration from "./registration/containers/index";
import { useAppUser } from "../contexts/user-context/UserContext";
import PublicWorkshopView from "./public-workshop-view/containers/PublicWorkshopView";
import PublicCompanyView from "./public-company/profile-view/PublicCompanyView";
import PublicCompanies from "./public-company/list-view/PublicCompanies";
// import MainDashboard from "./dashboard/containers/dashboard/containers/Dashboard";
import PublicLibraryView from "./public-workshops-view/containers/PublicLibraryView";

const Routes = () => {
  const { fireUser, userRole } = useAppUser();

  return useMemo(() => {
    return (
      <Router basename="/">
        <Switch>
          <Route
            path="/application/india"
            component={() => <Application country={Country.INDIA} />}
          />
          <Route
            path="/application/malaysia"
            component={() => <Application country={Country.MALAYSIA} />}
          />
          <Route
            path="/application/indonesia"
            component={() => <Application country={Country.INDONESIA} />}
          />
          <Route
            path="/application/srilanka"
            component={() => <Application country={Country.SRI_LANKA} />}
          />
          <Route
            path="/application/bih"
            component={() => <Application country={Country.BOSNIA} />}
          />
          <Route
            path="/application/jamaica"
            component={() => <Application country={Country.JAMAICA} />}
          />
          <Route path="/login" component={Login} />
          <Route path="/resetPassword" component={ResetPassword} />

          <Route
            path="/dashboard"
            component={() => {
              if (
                sessionStorage.getItem("isAuthed") === "true" ||
                localStorage.getItem("isAuthed") === "true" ||
                fireUser
              ) {
                return <Dashboard />;
              } else {
                return <Login />;
              }
            }}
          />
          <Route
            path="/signup/admin"
            component={() => {
              if (fireUser && userRole.isAdmin) {
                return (
                  <Registration
                    userRole={{
                      isAdmin: true,
                      isModerator: true,
                      isMember: true,
                    }}
                  />
                );
              } else {
                return <Login />;
              }
            }}
          />
          <Route
            path="/signup/moderator"
            component={() => {
              if (fireUser && userRole.isModerator) {
                return (
                  <Registration
                    userRole={{
                      isAdmin: false,
                      isModerator: true,
                      isMember: true,
                    }}
                  />
                );
              } else {
                return <Login />;
              }
            }}
          />
          <Route
            path="/signup/member"
            component={() => {
              if (fireUser && userRole.isModerator) {
                return (
                  <Registration
                    userRole={{
                      isAdmin: false,
                      isModerator: false,
                      isMember: true,
                    }}
                  />
                );
              } else {
                return <Login />;
              }
            }}
          />
          <Route
            path="/workshop/:id"
            component={() => {
              return <PublicWorkshopView />;
            }}
          />
          <Route
            path="/company/:id"
            component={() => {
              return <PublicCompanyView />;
            }}
          />
          <Route
            path="/companies"
            component={() => {
              return <PublicCompanies />;
            }}
          />
          {/* <Route
            path="/public/dashboard"
            component={() => {
              return <MainDashboard />;
            }}
          /> */}
          <Route
            path="/publiclibrary"
            component={() => {
              return <PublicLibraryView />;
            }}
          />
          <Route
            path="/dashboard"
            component={() => {
              if (
                sessionStorage.getItem("isAuthed") === "true" ||
                localStorage.getItem("isAuthed") === "true" ||
                fireUser
              ) {
                return <Dashboard />;
              } else {
                return <Login />;
              }
            }}
          />
          <Route
            path="/"
            component={() => {
              console.log("USER:", userRole);
              if (fireUser && userRole.isModerator) {
                return <Redirect to="/dashboard" />;
              } else {
                return <Redirect to="/publiclibrary" />;
              }
            }}
          />
        </Switch>
      </Router>
    );
  }, [fireUser, userRole]);
};

export default Routes;
